/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Uploader_UploadInputs */

const en_common_uploader_upload = /** @type {(inputs: Common_Uploader_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload`)
};

const zh_common_uploader_upload = /** @type {(inputs: Common_Uploader_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传`)
};

/**
* | output |
* | --- |
* | "Upload" |
*
* @param {Common_Uploader_UploadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_uploader_upload = /** @type {((inputs?: Common_Uploader_UploadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploader_UploadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_uploader_upload(inputs)
	return zh_common_uploader_upload(inputs)
});
export { common_uploader_upload as "common.uploader.upload" }